'use client';
import React, { useEffect, useState } from 'react';

import FooterBgLeft from '@/assets/icons/footerbg-left.svg';
import FooterBgRight from '@/assets/icons/footerbg-right.svg';
import SpeechBubble from '@/assets/icons/speechbubble.svg';
import Image from 'next/image';
import { isBrowser } from '../../helpers/is-browser';
import { footerIsMeetingPlace } from '../../helpers/list-page/type-guards';
import ImageWrapper from '../image-wrapper/Image-wrapper';
// import { FooterSliceContext } from '../../helpers/rendered-page-creation/create-slices';
import {
  clearUrlParams,
  getLocalStorageItem,
  setLocalStorageItem,
} from '../../helpers/utils';
import NewLetterForm from '../newsletter/newsletter-form';
import { OpeningHours } from '../opening-hours/opening-hours';
import { SocialMediaLinksList } from '../social-media-links-list/social-media-links-list';
import LinkWrapper from '../link-wrapper/link-wrapper';
import { Modal } from '../ui/modal/modal';
import { ModalBody } from '../ui/modal/modal-body';
import { SideModal } from '../ui/side-modal/side-modal';
import { SideModalBody } from '../ui/side-modal/side-modal-body';
import {
  useGetLibraryConstantsDictionaryData,
  useIsMPLivliFamily,
  useTenantConfig,
} from '@/providers/ConfigProvider';
import { useUser } from '@/providers/UserProvider';

export const Footer = ({
  footerData,
  layoutData,
  footerClass,
}: {
  footerData: any;
  layoutData: any;
  footerClass?: string;
}) => {
  const isLivliFamily = useIsMPLivliFamily();
  const [feedbackModalOpen, setFeedbackModallOpen] = useState<boolean>(false);
  const [sliderOpen, setSliderOpen] = useState<boolean>(false);
  const config = useTenantConfig();

  const { user } = useUser();
  const node_locale =
    layoutData?.meetingPlacePageHome?.meetingPlace?.sys?.locale;
  const dictionary = useGetLibraryConstantsDictionaryData();

  const meetingPlace = layoutData?.meetingPlacePageHome?.meetingPlace;
  const meetingPlaceFromFooterData =
    footerData?.meetingPlacePageHome?.meetingPlace;
  const footer = footerData?.meetingPlacePageHome?.footer;
  const isMeetingPlaceFooter = footerIsMeetingPlace(footer);

  const copyRightText =
    '© Ingka Centres Holding B.V. ' + new Date().getFullYear();

  const aspectRatio =
    meetingPlace?.logo?.width && meetingPlace?.logo?.height
      ? meetingPlace?.logo.width / meetingPlace?.logo.height
      : undefined;

  useEffect(() => {
    isBrowser &&
      typeof window.OneTrust !== 'undefined' &&
      window.OneTrust.initializeCookiePolicyHtml(true);
  }, []);

  if (!isMeetingPlaceFooter) return null;

  const sendEventToDataLayer = (interaction_type: string) => {
    if (isBrowser && dataLayer) {
      dataLayer.push({
        event: 'newsletter_form_subscription',
        user_subscribed: interaction_type,
        user_status: isLivliFamily ? (user ? 'logged_in' : 'guest') : undefined,
      });
    }
  };

  return (
    <>
      <footer
        className={`relative mt-auto pb-28 text-neutral-grey-700 md:pb-5 ${footerClass}`}
        data-elastic-exclude
      >
        <div className="relative mx-6 mt-20 xl:container lg:mt-24 lg:px-36 xl:px-28">
          <div className="grid xl:grid-flow-col">
            <div className="md:row-span-2 md:pr-28">
              <div className="mb-10 max-h-10 w-36">
                {meetingPlace?.logo && (
                  <ImageWrapper
                    alt="Logotype"
                    url={meetingPlace?.logo?.url}
                    className={
                      aspectRatio == 1
                        ? 'mb-10 max-h-15 w-36'
                        : 'mb-10 max-h-10 w-36'
                    }
                    imgClassName={
                      aspectRatio == 1 ? 'max-h-15 !w-auto' : 'max-h-10 !w-auto'
                    }
                    height={60}
                    width={144}
                  />
                )}
              </div>
            </div>
            <div className="text-bodym sm:col-span-3">
              <div className="pb-8 sm:pb-20">
                <div className="grid gap-8 sm:grid-cols-3 sm:gap-3 md:gap-8">
                  <div>
                    <h2 className="mb-2 font-title text-headings font-bold">
                      {meetingPlace?.name}
                    </h2>
                    {meetingPlaceFromFooterData?.visitorsAddressStreet &&
                      meetingPlaceFromFooterData?.visitorsAddressStreet}

                    {meetingPlaceFromFooterData?.visitorsAddressStreet2 && (
                      <br />
                    )}
                    {meetingPlaceFromFooterData?.visitorsAddressStreet2}

                    {(meetingPlaceFromFooterData?.visitorsAddressStreet ||
                      meetingPlaceFromFooterData?.visitorsAddressStreet2) && (
                      <br />
                    )}

                    {meetingPlaceFromFooterData?.visitorsAddressZipCode &&
                      `${meetingPlaceFromFooterData?.visitorsAddressZipCode} `}

                    {meetingPlaceFromFooterData?.visitorsAddressCity}

                    {(meetingPlaceFromFooterData?.visitorsAddressZipCode ||
                      meetingPlaceFromFooterData?.visitorsAddressCity) && (
                      <br />
                    )}
                    {meetingPlace?.phoneNumber && (
                      <a
                        className="underline lg:hover:text-text-light"
                        href={`tel:${meetingPlace?.phoneNumber?.replaceAll(
                          /\D+/g,
                          '',
                        )}`}
                      >
                        {meetingPlace?.phoneNumber}
                      </a>
                    )}
                  </div>
                  <div>
                    <div className="mb-3 font-title text-headings font-bold">
                      <OpeningHours
                        variant="today"
                        openingHoursClosed={
                          dictionary?.openingHoursClosed ?? ''
                        }
                        openingHoursClosedToday={
                          dictionary?.openingHoursClosedToday ?? ''
                        }
                        openingHoursOpenToday={
                          dictionary?.openingHoursOpenToday ?? ''
                        }
                        openingHours={meetingPlace?.openingHours}
                        openingHoursExceptions={meetingPlace?.openingHoursExceptionsCollection?.items?.filter(
                          Boolean,
                        )}
                        timezone={meetingPlace?.timezone}
                        node_locale={node_locale}
                      />
                    </div>
                    <div className="text-text-light">
                      <OpeningHours
                        openingHoursClosed={
                          dictionary?.openingHoursClosed ?? ''
                        }
                        openingHoursClosedToday={
                          dictionary?.openingHoursClosedToday ?? ''
                        }
                        openingHoursOpenToday={
                          dictionary?.openingHoursOpenToday ?? ''
                        }
                        openingHours={meetingPlace?.openingHours}
                        openingHoursExceptions={meetingPlace?.openingHoursExceptionsCollection?.items?.filter(
                          Boolean,
                        )}
                        timezone={meetingPlace?.timezone}
                        node_locale={node_locale}
                        variant="compact"
                      />
                    </div>
                    {footer?.allOpeningHoursLinkText &&
                      footer?.allOpeningHoursPageLink?.slug && (
                        <LinkWrapper
                          data={footer?.allOpeningHoursPageLink}
                          className="mt-2 inline-block underline lg:hover:text-text-light"
                        >
                          {footer.allOpeningHoursLinkText}
                        </LinkWrapper>
                      )}
                  </div>
                  <div>
                    <div className="relative mx-auto w-52 text-center lg:mx-0">
                      <SpeechBubble className="h-36 w-52" />
                      <div className="absolute left-2 top-0 flex h-[90%] w-full max-w-[90%] flex-col items-center justify-center p-4 text-brand-green-3">
                        {footer?.feedbackText && (
                          <h2 className="font-title text-headings">
                            {footer.feedbackText}
                          </h2>
                        )}
                        <div>
                          {footer?.feedbackLinkText && (
                            <button
                              className="text-bodys underline lg:hover:text-brand-green-2"
                              tabIndex={0}
                              onClick={() => setFeedbackModallOpen(true)}
                            >
                              {footer.feedbackLinkText}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pb-8 sm:pb-20">
                <div className="grid gap-0 text-bodys sm:grid-cols-3 sm:gap-8">
                  {footer?.linksCollection?.items
                    ?.filter(Boolean)
                    ?.map((menuGroup: any, index: number) => (
                      <ul
                        className="pt-6 first:pt-0 sm:pt-0"
                        key={`menu-group-${index}`}
                      >
                        {menuGroup?.pagesCollection?.items
                          ?.filter(Boolean)
                          ?.map((page: any, index: number) => (
                            <li key={`${page.name}-${index}`}>
                              {page?.__typename === 'LibraryPopupModal' ? (
                                <button
                                  id="newsletter-button"
                                  className="mb-3 text-bodys lg:hover:text-text-light lg:hover:underline"
                                  onClick={() => {
                                    window.scrollTo(0, 0);
                                    setSliderOpen(true);
                                  }}
                                >
                                  {page.name}
                                </button>
                              ) : (
                                <LinkWrapper
                                  data={page}
                                  className="mb-3 block lg:hover:text-text-light lg:hover:underline"
                                >
                                  {page.__typename === 'LibraryExternalLink'
                                    ? page.linkTitle
                                    : page.name}
                                </LinkWrapper>
                              )}
                            </li>
                          ))}
                        {index ===
                          footer.linksCollection?.items?.filter(Boolean)
                            ?.length -
                            1 && (
                          <button className="ot-sdk-show-settings mb-3 text-bodys lg:hover:text-text-light lg:hover:underline">
                            {dictionary?.cookieSettings}
                          </button>
                        )}
                      </ul>
                    ))}
                </div>
              </div>
              <div>
                <div className="flex flex-col items-center text-bodys lg:flex-row">
                  <div className="order-2 sm:order-1 lg:basis-1/3">
                    {copyRightText}
                  </div>
                  <div className="order-1 mb-10 mt-3 sm:my-0 lg:basis-2/3">
                    {meetingPlace?.socialMediaLinks && (
                      <SocialMediaLinksList
                        socialMediaLinks={meetingPlace.socialMediaLinks}
                        itemCssClass="mx-1.5 lg:mx-2.5 lg:ml-0 lg:mr-5"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pointer-events-none absolute bottom-0 left-0 -z-50 h-52 w-full sm:h-[31rem]">
          <FooterBgLeft className="absolute bottom-0 left-0 w-44 fill-accent-primary-normal lg:w-[26rem]" />
          <FooterBgRight className="absolute bottom-0 right-0 w-52 fill-accent-primary-normal lg:w-[31rem]" />
        </div>
      </footer>
      <Modal
        isOpen={feedbackModalOpen}
        handleClose={() => setFeedbackModallOpen(!feedbackModalOpen)}
      >
        <ModalBody>
          <iframe
            className="h-full w-full border-none lg:p-5"
            src={footer?.feedbackUrl}
          ></iframe>
        </ModalBody>
      </Modal>
      <SideModal
        isOpen={sliderOpen}
        handleClose={() => {
          if (isBrowser) {
            // Save to localStorage when the user closes the popup without subscribing
            setLocalStorageItem('hasClosedWithoutSubscribing', 'true');
            const hasSubscribedToNewsletter = getLocalStorageItem(
              'hasSubscribedToNewsletter',
            );
            if (!hasSubscribedToNewsletter) {
              sendEventToDataLayer('No');
            }
            setLocalStorageItem(
              'lastPopupClosedDate',
              new Date().toISOString(),
            );
          }
          setSliderOpen(!sliderOpen);
          // Clear URL params after state update
          setTimeout(() => {
            clearUrlParams();
          }, 100);
        }}
      >
        <SideModalBody>
          <NewLetterForm
            locale={node_locale}
            integrationId={meetingPlace?.integrationId}
            businessUnitCode={meetingPlace?.businessUnitCode}
            handleClose={() => {
              setSliderOpen(!sliderOpen);
              // Clear URL params after modal state update
              setTimeout(() => {
                clearUrlParams();
              }, 100);
            }}
          />
        </SideModalBody>
      </SideModal>
    </>
  );
};

export default Footer;
